import { render, staticRenderFns } from "./LoginViaApp.vue?vue&type=template&id=681e1879&scoped=true"
import script from "./LoginViaApp.vue?vue&type=script&lang=js"
export * from "./LoginViaApp.vue?vue&type=script&lang=js"
import style0 from "./LoginViaApp.vue?vue&type=style&index=0&id=681e1879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e1879",
  null
  
)

export default component.exports